var _style, _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContractPendingNordyne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Contract with Time") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.clockNeutral3Nordyne{fill:#dcdcdc;}\r\n\t\t.clockOpacityNordyne{opacity:100;}\r\n\t\t.clockBackgroundNordyne{fill-rule:evenodd;clip-rule:evenodd;fill:none;}\r\n\t\t.clockBorderNordyne{fill:#dcdcdc;}\r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "clockNeutral3Nordyne",
    d: "m40.3 0.1h-29.2c-2.5 0-4.6 2.1-4.6 4.7l-0.2 26.3h-5.6c-0.4 0-0.7 0.4-0.7 0.8v3.6c0 3.4 2.6 6.2 5.8 6.4v0.1h24.5 0.4c3.4 0 6.1-2.8 6.1-6.4v-23.1h7.4c0.4 0 0.7-0.4 0.7-0.8v-6.7c0.2-2.8-2-4.9-4.6-4.9zm-34.4 40.5c-2.6 0-4.6-2.3-4.6-5.2v-3.1h22.8v3c0 1.8 0.6 3.4 1.8 4.8 0.1 0.1 0.3 0.2 0.4 0.4 0 0-20.4 0.1-20.4 0.1zm29.6-5c0 2.7-2.1 5-4.8 5s-4.7-2.2-4.7-5v-3.6c0-0.4-0.3-0.8-0.8-0.8h-17.7l0.2-26.6c0-1.8 1.4-3.2 3.2-3.2h26c-0.8 0.9-1.4 2.1-1.4 3.4v30.8zm8.3-30.8v6h-6.9v-6c0-1.9 1.6-3.4 3.4-3.4 2-0.1 3.5 1.5 3.5 3.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "clockNeutral3Nordyne",
    d: "m29.9 22.6h-17.3c-0.4 0-0.8 0.3-0.8 0.6s0.3 0.6 0.8 0.6h17.4c0.4 0 0.8-0.3 0.8-0.6s-0.4-0.6-0.9-0.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "clockNeutral3Nordyne",
    d: "M29.9,27H12.6c-0.4,0-0.8,0.3-0.8,0.6s0.3,0.6,0.8,0.6H30c0.4,0,0.8-0.3,0.8-0.6S30.4,27,29.9,27z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "clockOpacityNordyne",
    transform: "translate(24 12)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "clockBackgroundNordyne",
    cx: -2.7,
    cy: 1.8,
    r: 5.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "clockBorderNordyne",
    d: "m-2.7 8.1c-3.5 0-6.3-2.8-6.3-6.3s2.8-6.3 6.3-6.3 6.3 2.8 6.3 6.3-2.9 6.3-6.3 6.3zm0-11.3c-2.8 0-5 2.3-5 5s2.3 5 5 5 5-2.3 5-5-2.3-5-5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clockBorderNordyne",
    d: "m-2.6-0.7c-0.2 0-0.4 0.2-0.4 0.5v2.3h-2.3c-0.3 0-0.5 0.3-0.5 0.5s0.3 0.5 0.5 0.5h3.3v-3.3c-0.1-0.3-0.3-0.5-0.6-0.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractPendingNordyne);
export default __webpack_public_path__ + "static/media/contract-pending-Nordyne.3bef142cfcd64a03bb816d814d673efa.svg";
export { ForwardRef as ReactComponent };